import React, { useState } from 'react'
import { Typography, Card, Form, Input, Button, Space, message, Descriptions, Row, Col } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import useAuthStore from '../store/authStore'

const { Title, Text } = Typography

const Profile = () => {
  const { admin, changePassword } = useAuthStore()
  const [changingPassword, setChangingPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const handleChangePassword = async (values) => {
    setLoading(true)
    const result = await changePassword(values.currentPassword, values.newPassword)

    if (result.success) {
      message.success('Password changed successfully')
      setChangingPassword(false)
      form.resetFields()
    } else {
      message.error(result.error || 'Failed to change password')
    }
    setLoading(false)
  }

  return (
    <div>
      <Title level={2}>My Profile</Title>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card title="Profile Information">
            <Descriptions column={1} bordered>
              <Descriptions.Item label="Full Name">
                {admin?.full_name || 'Not set'}
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {admin?.email}
              </Descriptions.Item>
              <Descriptions.Item label="Role">
                {admin?.is_super_admin ? 'Super Admin' : 'Platform Admin'}
              </Descriptions.Item>
              <Descriptions.Item label="Admin ID">
                {admin?.admin_id}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Security">
            {!changingPassword ? (
              <div className="text-center py-8">
                <LockOutlined className="text-4xl text-gray-400 mb-4" />
                <Text type="secondary" className="block mb-4">
                  Keep your account secure with a strong password
                </Text>
                <Button type="primary" onClick={() => setChangingPassword(true)}>
                  Change Password
                </Button>
              </div>
            ) : (
              <Form
                form={form}
                layout="vertical"
                onFinish={handleChangePassword}
              >
                <Form.Item
                  name="currentPassword"
                  label="Current Password"
                  rules={[{ required: true, message: 'Please enter your current password' }]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  name="newPassword"
                  label="New Password"
                  rules={[
                    { required: true, message: 'Please enter a new password' },
                    { min: 8, message: 'Password must be at least 8 characters' },
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  label="Confirm New Password"
                  dependencies={['newPassword']}
                  rules={[
                    { required: true, message: 'Please confirm your new password' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve()
                        }
                        return Promise.reject(new Error('Passwords do not match'))
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item>
                  <Space>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Update Password
                    </Button>
                    <Button onClick={() => {
                      setChangingPassword(false)
                      form.resetFields()
                    }}>
                      Cancel
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default Profile
